import SearchFiles from "../searchfiles";
import { Button } from "../ui";

interface FileToolbarProps {
  folderPath: string;
  roles: Array<number>;
  view: string;
  folderError: string;
  folderSuccess: string;
  toggleTab: () => void;
  toggleView: () => void;
  setView: (view: string) => void;
}

const FileToolbar = ({
  folderPath,
  roles,
  view,
  folderError,
  folderSuccess,
  toggleTab,
  toggleView,
  setView,
}: FileToolbarProps) => (
  <div className="relative flex items-center justify-between gap-5 mb-3 md:mb-0 md:order-2 md:justify-end">
    {process.env.REACT_APP_FILES_HAS_FILE_STATS === "true" &&
      (roles.includes(0) || roles.includes(1)) && (
        <div>
          <Button className="my-1" onClick={toggleTab}>
            File stats
          </Button>
        </div>
      )}
    <SearchFiles path={folderPath} />
    <div className="flex h-9 justify-between overflow-hidden border-y border-border/40 bg-white/70">
      <button
        className={`${
          view === "list"
            ? "bg-text text-white"
            : "bg-transparent hover:bg-shade"
        } relative -ml-px -mt-px inline-grid h-9 w-[45px] content-center gap-[3px] border border-border/25 px-[12px] py-0`}
        onClick={() => setView("list")}
      >
        <div className="h-px w-full bg-current" />
        <div className="h-px w-full bg-current" />
        <div className="h-px w-full bg-current" />
      </button>

      <div
        className={`${
          view !== "list"
            ? "bg-text text-white"
            : "bg-transparent hover:bg-shade"
        } -mr-px -mt-px inline-grid h-9 w-[45px] content-center border border-border/25 p-[10px]`}
      >
        <button
          onClick={toggleView}
          className=" hidden md:flex group gap-[2px] md:flex-wrap justify-center content-center"
        >
          <div
            className={`rounded-xs rounded-sm border border-current
                  ${view === "list" && "w-[calc(33.333%-2px)] h-1.5"} 
                  ${view === "small" && "w-[calc(33.333%-2px)] h-1.5"}
                  ${view === "medium" && "w-[calc(50%-2px)] h-2"} 
                  ${view === "large" && "w-4 h-4"} 
              `}
          />

          {view !== "large" && (
            <>
              <div
                className={` rounded-xs rounded-sm border border-current
                  ${view === "list" && "w-[calc(33.333%-2px)] h-1.5"} 
                  ${view === "small" && "w-[calc(33.333%-2px)] h-1.5"}
                  ${view === "medium" && "w-[calc(50%-2px)] h-2"} 
              
            `}
              />
              <div
                className={` rounded-xs rounded-sm border border-current
         ${view === "list" && "w-[calc(33.333%-2px)] h-1.5"} 
            ${view === "small" && "w-[calc(33.333%-2px)] h-1.5"}
            ${view === "medium" && "w-[calc(50%-2px)]  h-2"}  
            `}
              />
              <div
                className={` rounded-xs rounded-sm border border-current
                   ${view === "list" && "w-[calc(33.333%-2px)] h-1.5"} 
            ${view === "small" && "w-[calc(33.333%-2px)] h-1.5"}
            ${view === "medium" && "w-[calc(50%-2px)]  h-2"} 
            `}
              />
            </>
          )}

          {(view === "small" || view === "list") && (
            <>
              <div className="w-[calc(33.333%-2px)] h-1.5 rounded-xs rounded-sm border border-current" />
              <div className="w-[calc(33.333%-2px)] h-1.5 rounded-xs rounded-sm border border-current" />
            </>
          )}
        </button>
        <button
          onClick={() => setView("large")}
          className="grid md:hidden justify-items-center content-center gap-0.5 group"
        >
          <div className="rounded-xs h-4 w-4 rounded-sm border border-current" />
        </button>
      </div>
    </div>
    <p className="absolute text-sm italic text-red-700 -bottom-5">
      {folderError}
    </p>
    <p className="absolute text-sm italic text-green-600 -bottom-5">
      {folderSuccess}
    </p>
  </div>
);

export default FileToolbar;
